import React from 'react';
import { Link } from 'react-router-dom';

import StudentResults from '../../../types/StudentResults';
import Student from '../../../types/Student';

import Row from '../../common/ui/Table/Row';
import TableCell from '../../common/ui/Table/Cell';
import { calculateStudentNorms } from '../../../lib/studentResultsCalculator';
import Grade from '../../../types/Grade';

interface Props {
  student: Student;
  studentResults: StudentResults;
  grades: Record<number, Grade>;
}

type Variant = 'common' | 'warning' | 'danger';

const StudentsTableRow = ({
  student: {
    id,
    school,
    schoolId,
    username,
    sex,
    age,
    grade: studentGrade,
    orphan,
    visionImpairment,
    hearingImpairment,
    musculoskeletalImpairment,
    doneTesting,
  },
  grades,
  studentResults,
}: Props) => {
  const gradeId = studentGrade?.id;
  if (schoolId === undefined || gradeId === undefined) return <></>;

  const norms = calculateStudentNorms(studentResults?.testingTypeId, sex);

  return (
    <Row destroy={() => {}}>
      <TableCell variant="common">{username ?? ''}</TableCell>

      <TableCell variant="common">
        {school?.city?.municipality?.name ?? ''}
      </TableCell>

      <TableCell variant="common">{school?.city?.name ?? ''}</TableCell>

      <TableCell variant="common">{school?.name ?? ''}</TableCell>

      <TableCell variant="common">{sex ?? ''}</TableCell>

      <TableCell variant="common">{age ?? ''}</TableCell>

      <TableCell variant="common">
        {Object.values(grades).find((g) => g.id === studentGrade?.id)?.name ??
          ''}
      </TableCell>

      <TableCell variant="common">
        {Object.values(grades).find((g) => g.id === studentGrade?.id)?.letter ??
          ''}
      </TableCell>

      <TableCell>{orphan ? 'Да' : 'Нет'}</TableCell>
      
      <TableCell>{visionImpairment ? 'Да' : 'Нет'}</TableCell>
      
      <TableCell>{hearingImpairment ? 'Да' : 'Нет'}</TableCell>
      
      <TableCell>{musculoskeletalImpairment ? 'Да' : 'Нет'}</TableCell>

      <TableCell variant="common">{doneTesting ? 'Да' : 'Нет'}</TableCell>

      <TableCell
        variant={studentResults?.KVERIPO > norms.KVERIPO ? 'danger' : 'common'}
      >
        <Link to={`/admin/students/${id}`}>{studentResults?.KVERIPO ?? 0}</Link>
      </TableCell>

      <TableCell
        variant={(() => {
          if (studentResults?.IRP >= norms.IRP[1]) return 'extreme';
          if (studentResults?.IRP > norms.IRP[0]) return 'danger';
          return 'common';
        })()}
      >
        <Link to={`/admin/students/${id}`}>{studentResults?.IRP ?? 0}%</Link>
      </TableCell>

      <TableCell
        variant={
          ['common', 'danger', 'extreme'][
            studentResults?.result ?? 0
          ] as Variant
        }
      >
        <Link to={`/admin/students/${id}`}>
          {
            ['Низкая', 'Высокая', 'Высочайшая'][
              studentResults?.result ?? 0
            ]
          }
        </Link>
      </TableCell>
    </Row>
  );
};

export default StudentsTableRow;
